var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from 'axios';
import { AchievementApiClient, AuthApiClient, CampaignApiClient, CheckInApiClient, ChildApiClient, CourseApiClient, DescartesApiClient, EnrollmentApiClient, EulerApiClient, EvaluationApiClient, GroupApiClient, MagicWordApiClient, MarketingActivityApiClient, MiniGameApiClient, OrderApiClient, PointApiClient, PromotionApiClient, RedeemCodeApiClient, ReservationApiClient, SkuApiClient, SlmApiClient, TeacherApiClient, UserAccountApiClient, WechatApiClient, } from 'smartpi-core';
import { Container } from 'typedi';
import { toast } from '../components/Toast/Toast';
import { config } from '../config';
import { AuthManager } from './auth';
// TODO 后续需统一配置
export var API_BASE_URL = 'https://h5.congmingpai.com/api';
/**
 * 添加了基础配置的axios实例
 */
var axios = Axios.create({
    baseURL: config.API_ENDPOINT,
    withCredentials: true,
});
// TODO should give a namespace for instance object of axios with some interceptors
axios.interceptors.request.use(function (request) {
    request.headers.Authorization = Container.get(AuthManager).getToken();
    return request;
});
axios.interceptors.response.use(function (response) {
    return response;
}, function (err) {
    if (!err.response) {
        toast.fail('网络错误', 3);
    }
    return Promise.reject(err);
});
function request(param) {
    return __awaiter(this, void 0, void 0, function () {
        var data, method, url;
        return __generator(this, function (_a) {
            data = param.data, method = param.method, url = param.url;
            return [2 /*return*/, axios.request({ url: url, data: data, method: method })];
        });
    });
}
var H5AuthApiClient = /** @class */ (function (_super) {
    __extends(H5AuthApiClient, _super);
    function H5AuthApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    /**
     * 验证手机验证码
     *
     * @param {string} cellphone
     * @param {string} code
     * @returns {Promise<void>}
     * @memberof ApiClient
     */
    H5AuthApiClient.prototype.verifyCellphoneCode = function (cellphone, code) {
        return __awaiter(this, void 0, void 0, function () {
            var url, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = H5AuthApiClient.API_BASE_URL + "/auth/cellphone/bind/" + encodeURIComponent(cellphone) + "/verify/" + encodeURIComponent(code);
                        return [4 /*yield*/, this.requestAdaptor({ url: url, method: 'GET' })];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    return H5AuthApiClient;
}(AuthApiClient));
var H5AchievementApiClient = /** @class */ (function (_super) {
    __extends(H5AchievementApiClient, _super);
    function H5AchievementApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5AchievementApiClient;
}(AchievementApiClient));
var H5CampaignApiClient = /** @class */ (function (_super) {
    __extends(H5CampaignApiClient, _super);
    function H5CampaignApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5CampaignApiClient;
}(CampaignApiClient));
var H5CheckInApiClient = /** @class */ (function (_super) {
    __extends(H5CheckInApiClient, _super);
    function H5CheckInApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5CheckInApiClient;
}(CheckInApiClient));
var H5ChildApiClient = /** @class */ (function (_super) {
    __extends(H5ChildApiClient, _super);
    function H5ChildApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5ChildApiClient;
}(ChildApiClient));
var H5CourseApiClient = /** @class */ (function (_super) {
    __extends(H5CourseApiClient, _super);
    function H5CourseApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5CourseApiClient;
}(CourseApiClient));
var H5DescartesApiClient = /** @class */ (function (_super) {
    __extends(H5DescartesApiClient, _super);
    function H5DescartesApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5DescartesApiClient;
}(DescartesApiClient));
var H5EnrollmentApiClient = /** @class */ (function (_super) {
    __extends(H5EnrollmentApiClient, _super);
    function H5EnrollmentApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5EnrollmentApiClient;
}(EnrollmentApiClient));
var H5EulerApiClient = /** @class */ (function (_super) {
    __extends(H5EulerApiClient, _super);
    function H5EulerApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5EulerApiClient;
}(EulerApiClient));
var H5EvaluationApiClient = /** @class */ (function (_super) {
    __extends(H5EvaluationApiClient, _super);
    function H5EvaluationApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5EvaluationApiClient;
}(EvaluationApiClient));
var H5GroupApiClient = /** @class */ (function (_super) {
    __extends(H5GroupApiClient, _super);
    function H5GroupApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5GroupApiClient;
}(GroupApiClient));
var H5MarketingActivityApiClient = /** @class */ (function (_super) {
    __extends(H5MarketingActivityApiClient, _super);
    function H5MarketingActivityApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5MarketingActivityApiClient;
}(MarketingActivityApiClient));
var H5MiniGameApiClient = /** @class */ (function (_super) {
    __extends(H5MiniGameApiClient, _super);
    function H5MiniGameApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5MiniGameApiClient;
}(MiniGameApiClient));
var H5OrderApiClient = /** @class */ (function (_super) {
    __extends(H5OrderApiClient, _super);
    function H5OrderApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5OrderApiClient;
}(OrderApiClient));
var H5PointApiClient = /** @class */ (function (_super) {
    __extends(H5PointApiClient, _super);
    function H5PointApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5PointApiClient;
}(PointApiClient));
var H5PromotionApiClient = /** @class */ (function (_super) {
    __extends(H5PromotionApiClient, _super);
    function H5PromotionApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5PromotionApiClient;
}(PromotionApiClient));
var H5RedeemCodeApiClient = /** @class */ (function (_super) {
    __extends(H5RedeemCodeApiClient, _super);
    function H5RedeemCodeApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5RedeemCodeApiClient;
}(RedeemCodeApiClient));
var H5ReservationApiClient = /** @class */ (function (_super) {
    __extends(H5ReservationApiClient, _super);
    function H5ReservationApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5ReservationApiClient;
}(ReservationApiClient));
var H5SkuApiClient = /** @class */ (function (_super) {
    __extends(H5SkuApiClient, _super);
    function H5SkuApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5SkuApiClient;
}(SkuApiClient));
var H5SlmApiClient = /** @class */ (function (_super) {
    __extends(H5SlmApiClient, _super);
    function H5SlmApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5SlmApiClient;
}(SlmApiClient));
var H5TeacherApiClient = /** @class */ (function (_super) {
    __extends(H5TeacherApiClient, _super);
    function H5TeacherApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5TeacherApiClient;
}(TeacherApiClient));
var H5UserAccountApiClient = /** @class */ (function (_super) {
    __extends(H5UserAccountApiClient, _super);
    function H5UserAccountApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5UserAccountApiClient;
}(UserAccountApiClient));
var H5WechatApiClient = /** @class */ (function (_super) {
    __extends(H5WechatApiClient, _super);
    function H5WechatApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5WechatApiClient;
}(WechatApiClient));
var H5MagicWordApiClient = /** @class */ (function (_super) {
    __extends(H5MagicWordApiClient, _super);
    function H5MagicWordApiClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.requestAdaptor = request;
        return _this;
    }
    return H5MagicWordApiClient;
}(MagicWordApiClient));
var h5AuthApiClient = new H5AuthApiClient();
var h5CheckInApiClient = new H5CheckInApiClient();
var h5ChildApiClient = new H5ChildApiClient();
var h5CourseApiClient = new H5CourseApiClient();
var h5DescartesApiClient = new H5DescartesApiClient();
var h5EnrollmentApiClient = new H5EnrollmentApiClient();
var h5EulerApiClient = new H5EulerApiClient();
var h5EvaluationApiClient = new H5EvaluationApiClient();
var h5GroupApiClient = new H5GroupApiClient();
var h5MarketingActivityApiClient = new H5MarketingActivityApiClient();
var h5MiniGameApiClient = new H5MiniGameApiClient();
var h5OrderApiClient = new H5OrderApiClient();
var h5PointApiClient = new H5PointApiClient();
var h5PromotionApiClient = new H5PromotionApiClient();
var h5RedeemCodeApiClient = new H5RedeemCodeApiClient();
var h5ReservationApiClient = new H5ReservationApiClient();
var h5SkuApiClient = new H5SkuApiClient();
var h5SlmApiClient = new H5SlmApiClient();
var h5TeacherApiClient = new H5TeacherApiClient();
var h5UserAccountApiClient = new H5UserAccountApiClient();
var h5WechatApiClient = new H5WechatApiClient();
var h5AchievementApiClient = new H5AchievementApiClient();
var h5MagicWordApiClient = new H5MagicWordApiClient();
var h5CampaignApiClient = new H5CampaignApiClient();
export { h5AuthApiClient, h5CheckInApiClient, h5ChildApiClient, h5CourseApiClient, h5DescartesApiClient, h5EnrollmentApiClient, h5EulerApiClient, h5EvaluationApiClient, h5GroupApiClient, h5MarketingActivityApiClient, h5MiniGameApiClient, h5OrderApiClient, h5PointApiClient, h5PromotionApiClient, h5RedeemCodeApiClient, h5ReservationApiClient, h5SkuApiClient, h5SlmApiClient, h5TeacherApiClient, h5UserAccountApiClient, h5WechatApiClient, h5AchievementApiClient, h5MagicWordApiClient, h5CampaignApiClient, };
//# sourceMappingURL=api.js.map


//////////////////
// WEBPACK FOOTER
// ../core-h5/build/src/services/api.js
// module id = 166
// module chunks = 0